import { cn, HybridTooltip as DSHybridTooltip, Tooltip as DSTooltip } from "@eisox/design-system";

interface HybridTooltipProps {
  children?: React.ReactElement;
  content: React.ReactNode;
  position?: "top" | "right" | "bottom" | "left";
  openingCondition?: boolean;
  keepHoverOpen?: boolean;
  className?: string;
  forceMount?: true;
}

const HybridTooltip: React.FC<HybridTooltipProps> = ({
  children,
  content,
  position = "bottom",
  openingCondition = true,
  keepHoverOpen = true,
  forceMount,
  className,
}) => (
  <DSTooltip.Provider delayDuration={0}>
    <DSHybridTooltip.Root disableHoverableContent={!keepHoverOpen}>
      <DSHybridTooltip.Trigger asChild>{children}</DSHybridTooltip.Trigger>
      {content && openingCondition && (
        <DSHybridTooltip.Portal forceMount={forceMount}>
          <DSHybridTooltip.Content className={cn("z-1300", className)} side={position}>
            {content}
            <DSHybridTooltip.Arrow />
          </DSHybridTooltip.Content>
        </DSHybridTooltip.Portal>
      )}
    </DSHybridTooltip.Root>
  </DSTooltip.Provider>
);

HybridTooltip.displayName = "HybridTooltip";

export { HybridTooltip };
export type { HybridTooltipProps };
